/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Event_Group_HeaderInputs */

const en_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group`)
};

const fr_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements`)
};

const de_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe`)
};

const it_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi`)
};

const ru_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий`)
};

const es_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos`)
};

const zh_cn2_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप`)
};

const pt_pt2_iconik_publish_event_group_header = /** @type {(inputs: Iconik_Publish_Event_Group_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos`)
};

/**
* | output |
* | --- |
* | "Event Group" |
*
* @param {Iconik_Publish_Event_Group_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_event_group_header = /** @type {((inputs?: Iconik_Publish_Event_Group_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Event_Group_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_event_group_header(inputs)
	if (locale === "de") return de_iconik_publish_event_group_header(inputs)
	if (locale === "it") return it_iconik_publish_event_group_header(inputs)
	if (locale === "ru") return ru_iconik_publish_event_group_header(inputs)
	if (locale === "es") return es_iconik_publish_event_group_header(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_event_group_header(inputs)
	if (locale === "ja") return ja_iconik_publish_event_group_header(inputs)
	if (locale === "hi") return hi_iconik_publish_event_group_header(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_event_group_header(inputs)
	return en_iconik_publish_event_group_header(inputs)
});